module.exports = require('./assign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/object/extend.js
 ** module id = 516
 ** module chunks = 0
 **/